import React from 'react';
import AppBarTitle from '../../typography/AppBarTitle';

const PageBarTitle = () => <AppBarTitle>CityDAO Contract Admin</AppBarTitle>;
export default PageBarTitle;
